import { SET_SELECTED_UI_GROUPING } from 'actions';

export function setSelectedUiGrouping(selectedUiGrouping?: string) {
  return { selectedUiGrouping, type: SET_SELECTED_UI_GROUPING };
}
